import { Controller } from "@hotwired/stimulus"

// Submits the enclosing form whenever a chip is toggled, and clears all
// employee_ids[] inputs when the "Show all" reset button is clicked.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }

  reset(event) {
    event.preventDefault()
    this.element.querySelectorAll('input[name="employee_ids[]"]').forEach(i => { i.checked = false })
    this.element.requestSubmit()
  }
}
